import(/* webpackMode: "eager" */ "/var/www/apporb-web/frontend/node_modules/next/dist/client/link.js");
